import { ShowEpisode } from '@/api/models/showModels';

import { AppStorage } from './AppStorage';

const STORAGE_KEY = 'episodeProgress';

type EpisodeProgressMap = {
  [episodeId: string]: number;
};

export const saveEpisodeProgress = async (episodeId: string, currentTime: number): Promise<void> => {
  const raw = await AppStorage.getItem(STORAGE_KEY);
  const progressMap: EpisodeProgressMap = raw ? JSON.parse(raw) : {};

  progressMap[episodeId] = currentTime;

  await AppStorage.setItem(STORAGE_KEY, JSON.stringify(progressMap));
};

/**
 * Retrieve saved progress for a specific episode.
 */
export const getEpisodeProgress = async (episodeId: string): Promise<number | null> => {
  const raw = await AppStorage.getItem(STORAGE_KEY);
  const progressMap: EpisodeProgressMap = raw ? JSON.parse(raw) : {};

  const time = progressMap[episodeId];
  return typeof time === 'number' ? time : null;
};

/**
 * Clear progress for a specific episode.
 */
export const clearEpisodeProgress = async (episodeId: string): Promise<void> => {
  const raw = await AppStorage.getItem(STORAGE_KEY);
  const progressMap: EpisodeProgressMap = raw ? JSON.parse(raw) : {};

  delete progressMap[episodeId];

  await AppStorage.setItem(STORAGE_KEY, JSON.stringify(progressMap));
};

/**
 * Clear progress for all episodes.
 */
export const clearAllEpisodeProgress = async (): Promise<void> => {
  await AppStorage.deleteItem(STORAGE_KEY);
};

/**
 * Get the entire episode progress map.
 */
export const getAllEpisodeProgress = async (): Promise<EpisodeProgressMap> => {
  const raw = await AppStorage.getItem(STORAGE_KEY);
  return raw ? JSON.parse(raw) : {};
};

/**
 * Get the next episode id from an episode id.
 */
export const getNextEpisodeId = (episodes: ShowEpisode[], currentId: string): string | null => {
  const index = episodes.findIndex((ep) => ep.id === currentId);
  return index >= 0 && index + 1 < episodes.length ? episodes[index + 1].id : null;
};
